import {WorkflowType} from "./enums";
import {SimpleFacilityModel} from "./types/facility";

export const getFacilityWorkflowTypes = (
  facility?: SimpleFacilityModel,
): ReadonlyArray<string> =>
  facility?.availableWorkflows?.length
    ? facility.availableWorkflows
    : [WorkflowType.ADMISSION];

/** Sorted unique workflow types for the given facility IDs. */
export const getUnionWorkflowTypes = (
  facilityIds: ReadonlyArray<string> | null | undefined,
  facilitiesById: Record<string, SimpleFacilityModel | undefined>,
): ReadonlyArray<string> => {
  if (!facilityIds?.length) {
    return [];
  }

  const types = new Set<string>();

  facilityIds.forEach(facilityId => {
    getFacilityWorkflowTypes(facilitiesById[facilityId]).forEach(workflowType =>
      types.add(workflowType),
    );
  });

  return Array.from(types).sort();
};
